/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IBritaxProductRegistrationData } from './britax-product-registration.data';
import { IBritaxProductRegistrationProps } from './britax-product-registration.props.autogenerated';
import ProductRegistrationForm from './components/product.registration';
import {
    IModuleProps,
    INodeProps,
    IPayLoad,
    ITelemetryContent,
    getTelemetryObject,
    getPayloadObject
} from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
export interface IBritaxViewProps extends IBritaxProductRegistrationProps<IBritaxProductRegistrationData> {
    productRegistrationContainer?: IModuleProps;
    productRegistrationWrapper?: INodeProps;
}
export interface IBritaxProductRegistrationView extends IBritaxProductRegistrationProps<IBritaxProductRegistrationData> {
    productRegistrationNode?: React.ReactNode;
}
export interface IBritaxProductRegistrationViewProps
    extends IBritaxViewProps,
        IBritaxProductRegistrationView,
        IBritaxProductRegistrationProps<IBritaxProductRegistrationData> {}

/**
 *
 * BritaxProductRegistration component
 * @extends {React.PureComponent<IBritaxProductRegistrationProps<IBritaxProductRegistrationData>>}
 */
class BritaxProductRegistration extends React.PureComponent<IBritaxProductRegistrationProps<IBritaxProductRegistrationData>> {
    private readonly telemetryContent: ITelemetryContent;
    private readonly payLoad?: IPayLoad;

    constructor(props: IBritaxProductRegistrationProps<IBritaxProductRegistrationData>) {
        super(props);

        this.telemetryContent = getTelemetryObject(
            this.props.context.request.telemetryPageName!,
            this.props.friendlyName,
            this.props.telemetry
        );
        this.payLoad = getPayloadObject('click', this.telemetryContent, '');
        this.state = { isDisabled: false };
    }
    public render(): JSX.Element | null {
        const { config } = this.props;
        const moduleClassName = 'ms-product-registration';
        const viewprops: IBritaxProductRegistrationViewProps = {
            ...this.props,
            productRegistrationContainer: {
                moduleProps: this.props,
                className: classnames(moduleClassName, config.className)
            },
            productRegistrationWrapper: {
                moduleProps: this.props,
                className: classnames(`${moduleClassName}'__container'`, config.className)
            },
            productRegistrationNode: (
                <ProductRegistrationForm
                    props={this.props}
                    moduleClassName={moduleClassName}
                    telemetryContent={this.telemetryContent}
                    payLoad={this.payLoad}
                />
            )
        };

        return this.props.renderView(viewprops);
    }
}

export default BritaxProductRegistration;
